import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CanaryInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const isCanary = window.location.origin === 'https://canary.tourbo.com.ar';
    const isFrequentClients = req.url.includes('/frequent-clients');

    if (isCanary && isFrequentClients) {
      const canaryReq = req.clone({
        setHeaders: {
          'X-Canary': 'true',
        },
      });
      return next.handle(canaryReq);
    }
    return next.handle(req);
  }
}
